module.exports = "/** Example Less variable **/\n/** Colors **/\n"